import React from "react";
import {
  getCityByState,
  getStateList,
} from "../../actions/complaintsDataAction";
import { editComplaintData } from "../../actions/complaintsDataAction";
import { connect } from "react-redux";
import "./TicketDetailsEditor.css";

class TicketDetailsEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerDetails: props.customerDetails || {},
      complaintDetails:
        (props.complaintDetails && props.complaintDetails[0]) || {},
      states: [],
      cities: [],
      isEditable: false,
    };
  }
  handleBackClick = () => {
    this.props.backToForm(); // Calls the backToForm function from the parent component
  };
  componentDidMount() {
    this.getStateListApi();
    if (this.state.customerDetails.state_id) {
      this.loadCities(this.state.customerDetails.state_id);
    }
  }

  // Fetch states
  getStateListApi = async (param) => {
    try {
      const response = await this.props.getStateList(param);
      if (response && response.data.data) {
        this.setState({ states: response.data.data });
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      this.setState({ states: [] });
    }
  };

  // Fetch cities based on selected state_id
  loadCities = async (state_id) => {
    try {
      const response = await this.props.getCityByState({ state_id });
      if (response && response.data) {
        this.setState({ cities: response.data });
      } else {
        this.setState({ cities: [] });
      }
    } catch (e) {
      console.error("Failed to load cities:", e);
      this.setState({ cities: [] });
    }
  };

  // Handle customer detail changes (like state_id, city_id)
  handleCustomerChange = async (e) => {
    const { name, value } = e.target;
    let updatedCustomer = {
      ...this.state.customerDetails,
      [name]: value,
    };

    if (name === "state_id") {
      updatedCustomer.city_id = ""; // Reset city when state changes
      await this.loadCities(value); // Fetch cities based on the selected state
    }

    this.setState({ customerDetails: updatedCustomer });

    if (this.props.onCustomerChange) {
      this.props.onCustomerChange(name, value);
    }
  };

  // Handle complaint detail changes
  // handleComplaintChange = (e) => {
  //   const { name, value } = e.target;
  //   this.setState((prev) => ({
  //     complaintDetails: {
  //       ...prev.complaintDetails,
  //       [name]: value,
  //     },
  //   }));

  //   if (this.props.onComplaintChange) {
  //     this.props.onComplaintChange(name, value);
  //   }
  // };

  // Toggle edit mode
  toggleEditMode = () => {
    this.setState((prevState) => ({
      isEditable: !prevState.isEditable,
    }));
  };

  // Handle form submission
  handleSubmit = async () => {
    const { customerDetails, complaintDetails } = this.state;
      if (!customerDetails.address || customerDetails.address.trim() === "") {
        return alert("Address Line 1 is required.");
      }

      if (!customerDetails.address_2 || customerDetails.address_2.trim() === "") {
        return alert("Address Line 2 is required.");
      }

      if (!customerDetails.pincode) {
        return alert("Valid 6-digit pincode is required.");
      }

      if (!customerDetails.state_id || customerDetails.state_id == '0') {
        return alert("State is required.");
      }

      if (!customerDetails.city_id || customerDetails.city_id == '0') {
        return alert("City is required.");
      }
    const payload = {
      customer_id: customerDetails.customer_id,
      name: customerDetails.name,
      email: customerDetails.email,
      mobile: customerDetails.mobile,
      address1: customerDetails.address,
      address2: customerDetails.address_2 || "",
      pincode: customerDetails.pincode,
      state: customerDetails.state_id,
      city: customerDetails.city_id,
      //address1, address 2, state, city
      ticket_id: complaintDetails.ticket_id,
      product_id: complaintDetails.product_id,
      product_problem_id: complaintDetails.product_problem_id,
      sub_product_problem_id: complaintDetails.sub_product_problem_id,
      problem_description: complaintDetails.problem_description,
      purchase_date: complaintDetails.purchase_date,
      operating_software: complaintDetails.operating_software,
      complaint_id: complaintDetails.id,
      product_color_id: complaintDetails.product_color_id,
      is_meesho: true
    };
    this.callEditApi(payload);
    //   try {
    //     const res = await this.props.editComplaintData(payload);
    //     if (res && res.success) {
    //       alert("Complaint updated successfully!");
    //     } else {
    //       alert("Failed to update complaint.");
    //     }
    //   } catch (error) {
    //     console.error("Edit failed:", error);
    //     alert("Something went wrong while updating the complaint.");
    //   }
  };

  callEditApi = async (payload) => {
    await this.props.editComplaintData(payload);

    let editRes = this.props.editData;
    if (editRes.success) {
      window.location.reload();
      alert(editRes.message);
    } else {
      alert(this.props.editData.message);
    }
  };
  render() {
    const { customerDetails, complaintDetails, states, cities, isEditable } =
      this.state;

    return (
      <div className="ticket-details-editor">
        <div className="back-button-container">
          <button onClick={this.handleBackClick} className="back-button">
            <span className="arrow-left"></span> Back
          </button>
        </div>
        <h4>Customer Details</h4>

        <div className="form-group">
          <label>Name</label>
          <input
            name="name"
            value={customerDetails.name || ""}
            onChange={this.handleCustomerChange}
            className="form-control"
            readOnly={true} // Name is readonly
          />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            name="email"
            value={customerDetails.email || ""}
            onChange={this.handleCustomerChange}
            className="form-control"
            readOnly={true} // Email is readonly
          />
        </div>

        <div className="form-group">
          <label>Mobile</label>
          <input
            name="mobile"
            value={customerDetails.mobile || ""}
            onChange={this.handleCustomerChange}
            className="form-control"
            readOnly={true} // Mobile is readonly
          />
        </div>

        <div className="form-group">
          <label>Address</label>
          <input
            name="address"
            value={customerDetails.address || ""}
            onChange={(e) =>
              this.handleCustomerChange({
                target: {
                  name: e.target.name,
                  value: e.target.value.trimStart().slice(0, 128), // trim start + max length
                },
              })
            }
            className="form-control"
            maxLength={128} // limit address length
            readOnly={!isEditable} // address is readonly
          />
        </div>

        <div className="form-group">
          <label>Address Line 2</label>
          <input
            name="address_2"
            value={customerDetails.address_2 || ""}
            onChange={(e) =>
              this.handleCustomerChange({
                target: {
                  name: e.target.name,
                  value: e.target.value.trimStart().slice(0, 128),
                },
              })
            }
            className="form-control"
            maxLength={128}
            readOnly={!isEditable} // address is readonly
          />
        </div>

        <div className="form-group">
          <label>Pincode</label>
          <input
            name="pincode"
            value={customerDetails.pincode || ""}
            onChange={(e) =>
              this.handleCustomerChange({
                target: {
                  name: e.target.name,
                  value: e.target.value.replace(/\D/g, "").slice(0, 6), // numbers only, max 6
                },
              })
            }
            className="form-control"
            maxLength={6}
            readOnly={!isEditable}
          />
        </div>

        <div className="form-group">
          <label>State</label>
          <select
            name="state_id"
            value={customerDetails.state_id || ""}
            onChange={this.handleCustomerChange}
            className="form-control"
            readOnly={!isEditable} // address is readonly
            disabled={!isEditable}
          >
            <option value="">Select State</option>
            {states.length > 0
              ? states.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.state_name}
                  </option>
                ))
              : null}
          </select>
        </div>

        <div className="form-group">
          <label>City</label>
          <select
            name="city_id"
            value={customerDetails.city_id || ""}
            onChange={this.handleCustomerChange}
            className="form-control"
            // readOnly={!isEditable}
            disabled={!isEditable || !customerDetails.state_id} // City is editable only if state is selected and isEditable is true
            // disabled
          >
            <option value="">Select City</option>
            {cities.length > 0
              ? cities.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.city}
                  </option>
                ))
              : null}
          </select>
        </div>

        <hr />
        <h4>Complaint Details</h4>

        <div className="form-group">
          <label>Ticket ID</label>
          <input
            name="ticket_id"
            value={complaintDetails.ticket_id || ""}
            readOnly={true} // Ticket ID is readonly
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label>Product name</label>
          <input
            name="product_name"
            value={complaintDetails.product_name || ""}
            className="form-control"
            readOnly={true} // Product ID is readonly
          />
        </div>

        <div className="form-group">
          <label>Product Problem</label>
          <input
            name="product_problem"
            value={complaintDetails.product_problem || ""}
            onChange={this.handleComplaintChange}
            className="form-control"
            readOnly={!isEditable} // Product problem ID is editable only if isEditable is true
          />
        </div>

        <div className="form-group">
          <label>Problem Description</label>
          <textarea
            name="problem_description"
            value={complaintDetails.problem_description || ""}
            onChange={this.handleComplaintChange}
            className="form-control"
            readOnly={!isEditable} // Problem description is editable only if isEditable is true
          />
        </div>

        <div className="form-group">
          <label>Purchase Date</label>
          <input
            name="purchase_date"
            type="date"
            value={complaintDetails.purchase_date || ""}
            onChange={this.handleComplaintChange}
            className="form-control"
            readOnly={!isEditable} // Purchase date is editable only if isEditable is true
          />
        </div>

        <div className="form-group">
          <label>Operating Software</label>
          <input
            name="operating_software"
            value={complaintDetails.operating_software || ""}
            onChange={this.handleComplaintChange}
            className="form-control"
            readOnly={!isEditable} // Operating software is editable only if isEditable is true
          />
        </div>

        <div className="form-group">
          <label>Product Color ID</label>
          <input
            name="product_color_id"
            value={complaintDetails.product_color_id || ""}
            onChange={this.handleComplaintChange}
            className="form-control"
            readOnly={!isEditable} // Product color ID is editable only if isEditable is true
          />
        </div>

        {/* Edit and Submit buttons */}
        <div className="form-group">
          {!isEditable ? (
            <button onClick={this.toggleEditMode} className="btn btn-primary">
              Edit
            </button>
          ) : (
            <div>
              <button
                onClick={this.handleSubmit}
                className="btn"
                style={{
                  backgroundColor: "orange",
                  color: "white",
                  border: "none",
                }}
              >
                Submit
              </button>

              <button
                onClick={this.toggleEditMode}
                className="btn"
                style={{
                  backgroundColor: "black",
                  color: "white",
                  border: "none",
                }}
              >
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  getCityByState,
  getStateList,
  editComplaintData,
};

const mapStateToProps = (state) => ({
  editData: state.complaints.editData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TicketDetailsEditor);
